<ion-app>
  <ion-split-pane contentId="main-content" [disabled]="currentRoute === '/login'">
    <ion-menu contentId="main-content" type="overlay">
      <ion-content mode="md">
        <div class="menu-body">
          <div class="menu-brand">
            <img class="pamela" src="assets/pamela.webp" alt="" aria-hidden="true" />
            <div class="brand-text">
              <div class="brand-name gradient-text">Pamela</div>
              <div class="brand-subtitle">{{ "sidebar.control-center" | translate }}</div>
              @if (robotSerie) {
                <div class="robot-serie">
                  <span>{{ "sidebar.serial-number" | translate }}</span>
                  {{ robotSerie }}
                </div>
              }
              <ion-note>{{ "sidebar.welcome" | translate }}, {{ user ? user.email : "" }}</ion-note>
            </div>
          </div>

          <ion-list class="menu-nav">
            @for (p of appPages; track p; let i = $index) {
              @if (!p.hidden && (!p.requiresManyRobots || hasManyRobots)) {
                <ion-menu-toggle auto-hide="false">
                  <ion-item
                    routerDirection="root"
                    [routerLink]="[p.url]"
                    lines="none"
                    detail="false"
                    routerLinkActive="selected"
                    [class.selected-parent]="p.url === '/folder/tasks' && currentRoute === '/folder/new-task'"
                  >
                    <ion-icon aria-hidden="true" slot="start" [name]="p.icon + '-outline'"></ion-icon>
                    <ion-label>{{ p.title | translate }}</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              }
            }
          </ion-list>

          <ion-list class="menu-footer">
            <ion-item lines="none" detail="false">
              <ion-icon aria-hidden="true" slot="start" name="language-outline"></ion-icon>
              <ion-select
                [label]="'sidebar.language' | translate"
                interface="popover"
                [value]="translate.getCurrentLang()"
                (ionChange)="changeLanguage($event.detail.value)"
              >
                @for (lang of languages; track lang.code) {
                  <ion-select-option [value]="lang.code">{{ lang.label }}</ion-select-option>
                }
              </ion-select>
            </ion-item>

            <ion-item button="true" class="logout-item" lines="none" (click)="logout()" detail="false">
              <ion-icon color="danger" aria-hidden="true" slot="start" name="exit-outline"></ion-icon>
              <ion-label>{{ "sidebar.logout" | translate }}</ion-label>
            </ion-item>

            <app-powered-by class="menu-powered"></app-powered-by>
          </ion-list>
        </div>
      </ion-content>
      <div class="resize-handler" [class.grabbing]="resizing" (mousedown)="startResize($event)"></div>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
